// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-key-visual-module{position:relative;max-width:1024px;margin:0 auto}", ""]);
// Exports
module.exports = exports;
